class WebSocketService {
    constructor(url = "wss://socket.thalamus.ind.br", reconnectInterval = 3000) {
        this.url = url;
        this.reconnectInterval = reconnectInterval;
        this.ws = null;
        this.listeners = [];
        this.channels = new Set();
        this.shouldReconnect = true;
        this.reconnectTimeout = null;

        this.connect();
    }

    static _instance = null;
    static getInstance() {
        if (!WebSocketService._instance) {
            WebSocketService._instance = new WebSocketService();
        }
        return WebSocketService._instance;
    }

    connect() {
        this.ws = new WebSocket(this.url);

        this._onOpen = () => {
            if (process.env.NODE_ENV !== 'production') console.log("WebSocket conectado");
            this.channels.forEach((channel) => this.sendSubscribe(channel));
        };
        this._onMessage = (event) => this.notifyAll(event);
        this._onClose = () => {
            if (process.env.NODE_ENV !== 'production') console.warn("WebSocket encerrado. Reconectando...");
            this.reconnect();
        };
        this._onError = (error) => {
            if (process.env.NODE_ENV !== 'production') console.error("WebSocket error:", error);
            this.ws.close();
        };

        this.ws.addEventListener("open", this._onOpen);
        this.ws.addEventListener("message", this._onMessage);
        this.ws.addEventListener("close", this._onClose);
        this.ws.addEventListener("error", this._onError);
    }

    reconnect() {
        if (this.shouldReconnect && !this.reconnectTimeout) {
            this.reconnectTimeout = setTimeout(() => {
                if (process.env.NODE_ENV !== 'production') console.log("Reconectando WebSocket...");
                this.reconnectTimeout = null;
                this.connect();
            }, this.reconnectInterval);
        }
    }

    addListener(callback) {
        this.listeners.push(callback);
    }

    removeListener(callback) {
        this.listeners = this.listeners.filter((listener) => listener !== callback);
    }

    notifyAll(event) {
        this.listeners.forEach((listener) => listener(event));
    }

    isOpen() {
        return Boolean(this.ws && this.ws.readyState === WebSocket.OPEN);
    }

    subscribe(channel) {
        if (!channel) return;
        this.channels.add(channel);
        this.sendSubscribe(channel);
    }

    sendSubscribe(channel) {
        if (!this.isOpen()) return;
        this.send(JSON.stringify({ event: "pusher:subscribe", data: { channel } }));
    }

    send(message) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(message);
        } else if (process.env.NODE_ENV !== 'production') {
            console.warn("Conexão WebSocket está fechada, mensagem não enviada.");
        }
    }

    close() {
        this.shouldReconnect = false;
        clearTimeout(this.reconnectTimeout);
        if (this.ws) {
            try {
                this.ws.removeEventListener("open", this._onOpen);
                this.ws.removeEventListener("message", this._onMessage);
                this.ws.removeEventListener("close", this._onClose);
                this.ws.removeEventListener("error", this._onError);
                this.ws.close();
            } finally {
                this.ws = null;
            }
        }
    }
}

export default WebSocketService;
export const getWebSocketService = () => WebSocketService.getInstance();